// @view/invite/InviteAccept.view.tsx

import React from "react";
import type { InviteAcceptViewProps } from "@ps-bridge/contracts/inviteAccept";
import * as styles from "@styles/InviteAccept.css";
import "@styles/util/InviteAccept.global.css";
import InviteAcceptBodyPanel from "@view/panels/invite/InviteAcceptBody.panel";

const InviteAcceptView: React.FC<InviteAcceptViewProps> = ({
  password,
  confirmPassword,
  firstName,
  lastName,
  bodyPhase,
  onPasswordChange,
  onConfirmPasswordChange,
  onFirstNameChange,
  onLastNameChange,
  onSubmit,
}) => {
  return (
    <div className={styles.page} data-testid="page-inviteAccept" data-page-state="ready">
      <div className={styles.card}>
        <img
          className={styles.logo}
          src="/assets/ouroboros_logo_flat.png"
          alt="Ouroboros"
        />
        <h1 data-testid="invite-accept-heading">Accept your invite</h1>
        <p className={styles.subtitle} data-testid="invite-accept-subtitle">
          Set a password and add your name if it was not included with the invite.
        </p>

        <InviteAcceptBodyPanel
          bodyPhase={bodyPhase}
          password={password}
          confirmPassword={confirmPassword}
          firstName={firstName}
          lastName={lastName}
          onPasswordChange={onPasswordChange}
          onConfirmPasswordChange={onConfirmPasswordChange}
          onFirstNameChange={onFirstNameChange}
          onLastNameChange={onLastNameChange}
          onSubmit={onSubmit}
        />
      </div>
    </div>
  );
};

export default InviteAcceptView;
